import React from 'react';

class ContractItem extends React.Component {

  constructor(props) {
    super(props);

	this.onSelectionClicked = this.onSelectionClicked.bind(this);
  }
  
  onSelectionClicked() {
	this.props.onContractSelectionToggle(this.props.contractOption);
  }
  
  render() {

	var a = this;
	var b = a.props.contractOption;

	if(b.Selected && b.Offer != ""){
	return (
		<div id="ContractItem">
			<label className="radio-container">
				<input type="radio" value="{b.Name}" checked={b.Selected} onChange={() => a.onSelectionClicked()} />
				{b.Name} contract &pound;{b.Price.price}/{b.Price.frequency}
				<span className="d-block-mobile-only contract-duration-offer">{b.Offer} with all {b.Name} contracts</span>
				<span className="radio-checkmark contract-radio-checkmark"></span>
			</label>
		</div>
	);
	}
	else{
		return (
			<div id="ContractItem">
				<label className="radio-container">
					<input type="radio" value="{b.Name}" checked={b.Selected} onChange={() => a.onSelectionClicked()} />
					{b.Name} contract &pound;{b.Price.price}/{b.Price.frequency}
					<span className="radio-checkmark"></span>
				</label>
			</div>
		);
	}
  }
};

export default ContractItem;



// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Components/ContractItem.es6